// extracted by mini-css-extract-plugin
export default {"wrapper":"layout_wrapper__ConKj","content":"layout_content__zmFCj"};